import React, { useState, useEffect } from "react";
import AdminDashboard from "../../AdminDashboard"
import { isAuthenticated } from "../../../../auth"
import { createCategory, createMultipleCategories } from "../../apiAdmin"
import {countOfCategories} from "../../../apiCore"
import { Redirect } from "react-router-dom";
import { from } from "form-data";
import { default_url } from "../../../..";
import { dict } from "../../../../dictionary";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }));

function AddCategory() {
    const classes = useStyles();
    const [values, setValues] = useState({
        enName: "",
        arName: "",
        hasSubcategory: "",
        hidden: "",
        image: "",
        error: "",
        redirectToReferrer: false,
        formData: ""
    });
    const [mood, setMood] = useState({
        single: true,
        multiple: false
    })
    const [numOfCategories, setNumOfCategories] = useState(0);
    const { user, token } = isAuthenticated();
    const { enName, arName, hasSubcategory, hidden, image, error, redirectToReferrer, formData } = values;
    const { single, multiple } = mood;
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        async function fetchData() {
            await countOfCategories()
                .then(res => {
                    setNumOfCategories(res);
                })
        }
        fetchData();
    }, []);

    useEffect(() => {
        setValues({ ...values, formData: new FormData() });
    }, []);

    const handleChange = name => event => {
        if (single) {
            setValues({ ...values, error: false, [name]: event.target.value });
        } else {
            for (let i = 0; i < event.target.files.length; i++) {
                formData.set(`categories`, event.target.files[i]);
            }
        }
    };

    const handleCheckBoxChange = name => event => {
        if (name == "single") {
            setMood({ 'single': event.target.checked, 'multiple': !event.target.checked });
        } else {
            setMood({ 'single': !event.target.checked, 'multiple': event.target.checked });
        }
    }

    const clickSubmit = (event) => {
        event.preventDefault();
        if (!single && !multiple) {
            return;
        }
        setLoading(true);
        if (single) {
            const position = numOfCategories + 1;
            createCategory({ enName, arName, hasSubcategory, hidden, image, position }, user._id, token)
                .then(data => {
                    setLoading(false);
                    if (data.error) {
                        setValues({ ...values, error: dict[data.error], redirectToReferrer: false });
                    } else {
                        setValues({
                            enName: "",
                            arName: "",
                            hasSubcategory: "",
                            hidden: "",
                            image: "",
                            error: undefined,
                            redirectToReferrer: true,
                            formData: ""
                        });
                    }
                })
        } else {
            createMultipleCategories(formData, user._id, token)
                .then(data => {
                    setLoading(false);
                    if (data.error) {
                        setValues({ ...values, error: data.error, redirectToReferrer: false });
                    } else {
                        setValues({
                            enName: "",
                            arName: "",
                            hasSubcategory: "",
                            hidden: "",
                            image: "",
                            error: undefined,
                            redirectToReferrer: true,
                            formData: ""
                        });
                    }
                })
        }
    }

    const hasSubcategorySelector = () => {
        return (
            <select onChange={handleChange("hasSubcategory")} name="hasSubcategory" className="inputField form-control" value={hasSubcategory}>
                <option value=""></option>
                <option value="yes">{dict["yes_._it_has_subcategory"]}</option>
                <option value="no">{dict["no_._it_hasn't_subcategory"]}</option>
            </select>
        )
    }

    const hiddenSelector = () => {
        return (
            <select onChange={handleChange("hidden")} name="hidden" className="inputField form-control" value={hidden}>
                <option value=""></option>
                <option value="no">{dict["no_._it_isn't_hidden"]}</option>
                <option value="yes">{dict["yes_._it_is_hidden"]}</option>
            </select>
        )
    }

    const showError = () => {
        return (
            <div className="alert alert-danger" style={{ display: error ? "" : "none" , textAlign: 'start'}}>
                {error}
            </div>
        )
    }

    const redirectUser = () => {
        if (redirectToReferrer) {
            return (
                <Redirect to={{ pathname: default_url + 'admin/categories', state: { prevPath: "create", error } }} />
            )
        }
    }

    const arStyleRequiredStart = {
        left: "30px"
    }
    const enStyleRequiredStart = {
        right: "30px"
    }
    const arStylelabel = {
        float: "right"
    }
    const enStylelabel = {
        float: "left"
    }

    const singleCategory = () => {
        return (
            <div className="signleCategoryForm" style={{ display: single ? "" : "none" }}>
                <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["category_english_name"]} <span className="redStar">*</span></label>
                <input onChange={handleChange("enName")} type="text" value={enName} className="inputField form-control" id="name" placeholder={dict["category_english_name"]}></input>
                <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["category_arabic_name"]} <span className="redStar">*</span></label>
                <input onChange={handleChange("arName")} type="text" value={arName} className="inputField form-control" id="name" placeholder={dict["category_arabic_name"]}></input>
                <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["has_subcategory"]} <span className="redStar">*</span></label><br />
                {hasSubcategorySelector()}
                <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["hidden"]} <span className="redStar">*</span></label><br />
                {hiddenSelector()}
                <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["category_image"]} <span className="redStar">*</span></label>
                <input onChange={handleChange("image")} type="text" value={image || ""} className="inputField form-control" id="image" placeholder={dict["category_image"]}></input>
            </div>
        )
    }
    const multipleCategories = () => {
        return (
            <div className="multipleCategoriesForm" style={{ display: multiple ? "" : "none" }}>
                <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["excel_file"]} <span className="redStar">*</span></label>
                <input onChange={handleChange("excel")} type="file" multiple className="inputField form-control" name="photo" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"></input>
            </div>
        )
    }
    
    const showBackdrop = () => {
        return (
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    const form = () => {
        return (
            <div className="userProfileDataContainer">
                {showBackdrop()}
                {showError()}
                {redirectUser()}
                <h3 className="formContainerTitle">{dict["add_new_category"]}</h3>
                <h6 className="requiredStar requiredStarUserDashbord" style={default_url == "/en/" ? enStyleRequiredStart : arStyleRequiredStart}>{dict["required"]}</h6>
                <form >
                    <div className="form-check checkBoxAddCategory">
                        <input onChange={handleCheckBoxChange("single")} type="checkbox" checked={single} className="form-check-input addCategoryCheckInput" id="exampleCheck1" />
                        <label className="form-check-label" for="exampleCheck1">{dict["add_one_category"]}</label>
                    </div>
                    {singleCategory()}
                    <div className="form-check checkBoxAddCategory">
                        <input onChange={handleCheckBoxChange("multiple")} type="checkbox" checked={multiple} className="form-check-input addCategoryCheckInput" id="exampleCheck1" />
                        <label className="form-check-label" for="exampleCheck1">{dict["add_multiple_categories"]}</label>
                    </div>
                    {multipleCategories()}
                    <button onClick={clickSubmit} type="submit" className="dashboardBtn">{dict["save"]}</button>
                </form>
            </div>
        )
    }

    return (
        <AdminDashboard
            active="2"
            data={form}
        />
    )
}

export default AddCategory;